import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { X, Check } from 'lucide-react';
const rows = [{
  bad: 'Hablan solo de logística, nunca de cómo se sienten',
  good: '1 carta de conversación por semana, sin esfuerzo de armar el tema'
}, {
  bad: 'Los miedos se acumulan en silencio, cada uno por su lado',
  good: 'Frases listas para nombrar miedos sin que se vuelvan pesados'
}, {
  bad: "Él se siente 'de más' y se aleja sin saber por qué",
  good: 'Rol activo y propio para él desde la semana 1'
}, {
  bad: 'Pelean por cosas chicas que tapan miedos grandes',
  good: 'Guiones para las conversaciones difíciles antes de que escalen'
}, {
  bad: 'Sin forma de medir si están más cerca o más lejos',
  good: 'Tracker de nosotros semanal, los 9 meses'
}, {
  bad: 'La familia y el entorno presionan sin que lo decidan',
  good: 'Frases y límites acordados frente a la presión externa'
}, {
  bad: 'Llegan al tercer trimestre más cansados y más distantes',
  good: 'Llegan al tercer trimestre más equipo que el primer día'
}];
export function Comparison() {
  return <section className="py-12 md:py-24 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-35">
      <SectionHeading title="LA REALIDAD" subtitle="¿Cuánto cuesta NO tenerlo?" data-id="element-36" />

      {/* Mobile Stacked View */}
      <div className="md:hidden space-y-4" data-id="element-37">
        {rows.map((row, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-offwhite rounded-xl border border-brown/10 overflow-hidden shadow-sm" data-id="element-38">
            <div className="p-4 bg-cream border-b border-brown/5 flex gap-3 items-start" data-id="element-39">
              <X className="text-brown/40 shrink-0 mt-0.5" size={18} data-id="element-40" />
              <span className="font-sans text-sm text-brown/70" data-id="element-41">{row.bad}</span>
            </div>
            <div className="p-4 bg-terracotta/5 flex gap-3 items-start" data-id="element-42">
              <Check className="text-terracotta shrink-0 mt-0.5" size={18} data-id="element-43" />
              <span className="font-sans text-sm text-brown font-medium" data-id="element-44">
                {row.good}
              </span>
            </div>
          </motion.div>)}
      </div>

      {/* Desktop Table View */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="hidden md:block bg-offwhite rounded-2xl border border-brown/10 overflow-hidden shadow-sm" data-id="element-45">
        <div className="grid grid-cols-2 bg-brown text-offwhite" data-id="element-46">
          <div className="p-6 text-center font-serif font-bold text-lg border-r border-offwhite/10" data-id="element-47">
            Sin el sistema
          </div>
          <div className="p-6 text-center font-serif font-bold text-lg bg-terracotta" data-id="element-48">
            Con el sistema
          </div>
        </div>

        <div className="divide-y divide-brown/5" data-id="element-49">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-cream' : 'bg-offwhite'}`} data-id="element-50">
              <div className="p-6 flex items-start gap-3 border-r border-brown/5" data-id="element-51">
                <X className="text-brown/40 shrink-0 mt-0.5" size={20} data-id="element-52" />
                <span className="font-sans text-base text-brown/70" data-id="element-53">
                  {row.bad}
                </span>
              </div>
              <div className="p-6 flex items-start gap-3 bg-terracotta/[0.02]" data-id="element-54">
                <Check className="text-terracotta shrink-0 mt-0.5" size={20} data-id="element-55" />
                <span className="font-sans text-base text-brown font-medium" data-id="element-56">
                  {row.good}
                </span>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}